import React, { useState, useEffect } from 'react';
import { Mail, MailOpen, Search } from 'lucide-react';
import { authService } from '../../services/auth';

const ContactMessagesPage = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadMessages();
  }, []);

  const loadMessages = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/contact`, {
        headers: authService.getAuthHeaders()
      });
      const data = await response.json();
      setMessages(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error cargando consultas:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleRead = async (id, currentRead) => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL || '/api'}/contact/${id}`, {
        method: 'PATCH',
        headers: authService.getAuthHeaders(),
        body: JSON.stringify({ read: !currentRead })
      });
      setMessages(prev => prev.map(m => (m.id === id ? { ...m, read: currentRead ? 0 : 1 } : m)));
    } catch (error) {
      console.error('Error actualizando consulta:', error);
    }
  };

  const filteredMessages = messages.filter(m =>
    `${m.nombre} ${m.apellido} ${m.email} ${m.mensaje}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800">Consultas</h1>
        <p className="text-gray-600">Mensajes recibidos desde el formulario de contacto de la web</p>
      </div>

      <div className="bg-white rounded-xl shadow p-6 mb-6">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="text"
            placeholder="Buscar por nombre, email o mensaje..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          />
        </div>
      </div>

      <div className="bg-white rounded-xl shadow divide-y divide-gray-100">
        {filteredMessages.map((message) => (
          <div key={message.id} className={`p-6 ${!message.read ? 'bg-blue-50/40' : ''}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-semibold text-gray-800">{message.nombre} {message.apellido}</h3>
                  {message.tipoInteres && (
                    <span className="px-2 py-0.5 text-xs rounded-full bg-blue-100 text-blue-700">
                      {message.tipoInteres}
                    </span>
                  )}
                  {!message.read && (
                    <span className="px-2 py-0.5 text-xs rounded-full bg-red-100 text-red-700">Nueva</span>
                  )}
                </div>
                <p className="text-sm text-gray-500">{message.email}</p>
                <p className="text-gray-700 mt-2">{message.mensaje}</p>
                <p className="text-xs text-gray-400 mt-2">
                  {new Date(message.createdAt).toLocaleString('es-AR')}
                </p>
              </div>
              <button
                onClick={() => toggleRead(message.id, message.read)}
                className="p-2 text-gray-500 hover:bg-gray-100 rounded-lg flex-shrink-0"
                title={message.read ? 'Marcar como no leída' : 'Marcar como leída'}
              >
                {message.read ? <MailOpen className="w-5 h-5" /> : <Mail className="w-5 h-5" />}
              </button>
            </div>
          </div>
        ))}

        {filteredMessages.length === 0 && (
          <div className="text-center py-16">
            <Mail className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-600">
              {searchTerm ? 'No hay consultas que coincidan con la búsqueda' : 'Todavía no llegó ninguna consulta'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactMessagesPage;
